import mapboxgl from "mapbox-gl";

/**
 * Validate coordinates are within Turkey bounds
 */
export function isValidCoordinate(lon, lat) {
  return (
    typeof lon === "number" &&
    typeof lat === "number" &&
    Number.isFinite(lon) &&
    Number.isFinite(lat) &&
    lon >= 25.5 &&
    lon <= 45.0 &&
    lat >= 35.5 &&
    lat <= 42.5
  );
}

/**
 * Fit map bounds to show all markers
 */
export function fitMapToMarkers(map, coords, animate = false) {
  if (!map || !coords.length) return;
  if (coords.length === 1) {
    map.flyTo({ center: coords[0], zoom: 12, animate });
    return;
  }
  const bounds = coords.reduce(
    (b, c) => b.extend(c),
    new mapboxgl.LngLatBounds(coords[0], coords[0])
  );
  map.fitBounds(bounds, { padding: 60, animate, maxZoom: 14 });
}

/**
 * Compute valid coordinates from listings array
 */
export function computeValidCoords(listingsArray) {
  return (Array.isArray(listingsArray) ? listingsArray : [])
    .map((l) => {
      if (!l?.coordinate) return null;
      const { lon, lat } = l.coordinate;
      if (!isValidCoordinate(lon, lat)) return null;
      return [lon, lat];
    })
    .filter(Boolean);
}

// Emlakjet brand colors
export const MARKER_COLOR = "#16a34a";
export const MARKER_COLOR_SELECTED = "#0d9488"; // Teal for selected
export const MARKER_COLOR_HOVER = "#15803d";

/**
 * Create marker element with styling
 */
export function createMarkerElement(priceLabel, isSelected = false, isDark = false) {
  const el = document.createElement('div');
  el.className = 'price-marker';
  el.style.cssText = `
    padding: ${isSelected ? '5px 12px' : '4px 10px'};
    background: ${isSelected ? MARKER_COLOR_SELECTED : MARKER_COLOR};
    color: white;
    border-radius: 16px;
    font-size: ${isSelected ? '13px' : '12px'};
    font-weight: 600;
    white-space: nowrap;
    cursor: pointer;
    box-shadow: ${isSelected ? '0 4px 16px rgba(0,0,0,0.5)' : '0 2px 8px rgba(0,0,0,0.3)'};
    border: ${isSelected ? '3px solid white' : '2px solid white'};
  `;
  el.textContent = priceLabel || '₺';
  return el;
}

/**
 * Update marker element styles based on selection state
 */
export function updateMarkerStyle(element, isSelected) {
  element.style.background = isSelected ? MARKER_COLOR_SELECTED : MARKER_COLOR;
  element.style.boxShadow = isSelected ? '0 4px 16px rgba(0,0,0,0.5)' : '0 2px 8px rgba(0,0,0,0.3)';
  element.style.padding = isSelected ? '5px 12px' : '4px 10px';
  element.style.fontSize = isSelected ? '13px' : '12px';
  element.style.border = isSelected ? '3px solid white' : '2px solid white';
}
